/**
 * Tipi di blocchi disponibili per le sezioni homepage
 */
export const INFO_BANNER_BLOCK = "info-banner";
export const VALUE_PROPOSITION_BLOCK = "value-proposition";
export const POINT_LIST_BLOCK = "point-list";

/**
 * Crea un blocco informativo con link e contenuto personalizzabile
 * @param {Object} props - Proprietà del blocco (more_link, image, title, description)
 * @returns {Object} Blocco con type e props
 */
export const build_info_banner_block = (
  props = {
    more_link: {
      to: { name: "about", hash: "#prenota-un-viaggio" },
      text: "Scopri di più...",
    },
  },
) => ({
  type: INFO_BANNER_BLOCK,
  props,
});

/**
 * Crea un blocco value proposition con lista di items
 * @param {Array} items - Array di oggetti {vp_image, vp_content: [{vp_icon, vp_title, vp_text}]}
 * @returns {Object} Blocco con type e props
 */
export const build_value_proposition_block = (items = []) => ({
  type: VALUE_PROPOSITION_BLOCK,
  props: {
    vp: items,
  },
});

/**
 * Crea un blocco point list con lista di punti
 * @param {Array} items - Array di oggetti {pl_icon, pl_title, pl_text}
 * @returns {Object} Blocco con type e props
 */
export const build_point_list_block = (items = []) => ({
  type: POINT_LIST_BLOCK,
  props: {
    pl: items,
  },
});

/**
 * Estrae i valori comuni dalla configurazione del sito
 * Centralizza il destructuring per evitare ripetizioni nei brand
 * @param {Object} config - Configurazione globale dell'app (da Vuex)
 * @returns {Object} Oggetto con {phoneNumber, brand, payoff}
 */
export const get_site_config = (config = {}) => {
  const { site: { phoneNumber = "", brand = "", payoff = "" } = {} } = config;
  return { phoneNumber, brand, payoff };
};

/**
 * Contenuto di default per brand non specificati
 * Usato come fallback quando il brand non ha una configurazione dedicata
 * @param {Object} config - Configurazione globale dell'app
 * @returns {Array} Array di blocchi sezione
 */
export const build_default_content = (config = {}) => {
  const { phoneNumber, brand, payoff } = get_site_config(config);
  return [
    build_info_banner_block(),
    build_value_proposition_block([
      {
        vp_image: "assets/images/liveeps/statics/iStock-1208856002.jpg",
        vp_content: [
          {
            vp_icon: "symbol_lb",
            vp_title: "Supporto rapido e dedicato",
            vp_text: `Il nostro customer care è composto da professionisti del travel, pronti a rispondere con competenza e rapidità a ogni tua richiesta. 
            <strong>
              <a href="${phoneNumber}">
                Chiamaci allo ${phoneNumber} 
              </a>
            </strong>`,
          },
          {
            vp_icon: "symbol_lb",
            vp_title: "Su di noi puoi contare!",
            vp_text: `Solo ${brand} ${payoff} ti offre un'assistenza multicanale, telefonica, webchat, WhatsApp, email, webcall a portata di click e dedicata a gli utenti di welfare aziendale. `,
            vp_support_action: "Parla con noi!",
            vp_cta_id: "section-vp-multichannel",
          },
        ],
      },
    ]),
    build_point_list_block([
      {
        pl_icon: "shield",
        pl_title: "Un mondo di viaggi",
        pl_text:
          "Straordinari contenuti per te grazie alla nostra partnership con il leader globale del travel online Expedia",
      },
      {
        pl_icon: "happy_pin",
        pl_title: "Per il welfare aziendale",
        pl_text:
          "Un servizio progettato per i lavoratori delle aziende italiane, dal sito web al servizio di assistenza",
      },
      {
        pl_icon: "hands",
        pl_title: "La nostra assistenza",
        pl_text:
          "Un team di assistenza italiano con esperienza pluriennale di supporto ai titolari di welfare aziendale",
      },
    ]),
  ];
};
